import type { Tag, TagType } from '@/types/tag';

const LOCATION_TAG_COLORS = [
  '#34D399',
  '#60A5FA',
  '#F472B6',
  '#F59E0B',
  '#A78BFA',
  '#22D3EE',
  '#FB7185',
  '#4ADE80',
  '#38BDF8',
  '#FBBF24',
  '#C084FC',
  '#2DD4BF',
];

const hashString = (value: string): number => {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
};

export const getDefaultTagColor = (tagType: TagType, seed: string): string | undefined => {
  if (tagType !== 'location') return undefined;
  const index = hashString(seed) % LOCATION_TAG_COLORS.length;
  return LOCATION_TAG_COLORS[index];
};

export const getTagDisplayColor = (tag: Pick<Tag, 'tagType' | 'color' | 'name' | 'id'>): string | undefined => {
  if (tag.tagType !== 'location') return undefined;
  return tag.color || getDefaultTagColor('location', tag.name || tag.id);
};
